import store from "@/store";

import AssetSubTypeService from '@/services/AssetSubTypeService';
import EmoTemplateService from '@/services/EmoTemplateService';
import EnergySourceService from '@/services/EnergySourceService';
import EnergyUseCatService from '@/services/EnergyUseCatService';
import SitePrimaryFunctionService from '@/services/SitePrimaryFunctionService';
import UnitService from '@/services/UnitService';
import CountryService from '@/services/CountryService';
import IssueCategoryService from "../services/IssueCategoryService";

export async function loadAllLookups() {
  const current_instance = store.getters.currentInstance;

  console.log("Inside common/app_config loadAllLookups, current_instance ==> ", current_instance)

  if (current_instance) {
    await AssetSubTypeService.loadAll();
    await EmoTemplateService.loadAll();
    await EnergySourceService.loadAll();
    await EnergyUseCatService.loadAll();
    await SitePrimaryFunctionService.loadAll();
    await CountryService.loadAll();
    await UnitService.loadAll();
    await IssueCategoryService.loadAll();
  }  
}